import { Http } from '@intelipost-js/secure-providers';

// eslint-disable-next-line import/prefer-default-export
export const uploadFileToRemoteUrl = (url, file, progressCallback = undefined) => {
  const { type, fileType, size, fileSize, file: fileStream } = file;

  const uploadUptions = {
    headers: {
      'Content-Type': type || fileType,
      'Content-Length': size || fileSize,
    },
    transformRequest: (reqData, reqHeaders) => {
      // remove authentication headers so S3 will accept request
      delete reqHeaders['Authorization']; //eslint-disable-line
      delete reqHeaders['token']; //eslint-disable-line
      return reqData;
    },
    ...(!!progressCallback && { onUploadProgress: progressCallback }),
  };

  return Http.put(url, fileStream || file, uploadUptions);
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/store/commons.js